import { call, put } from "redux-saga/effects";
import { getMinStaticContent } from "@takedapdt/biolife-cms-kit";
import { updateToolkitResponseForChildren } from "../../../Utils/commonHelpers";
import importer from "common/importer";
const { drupalFormFilter } = importer("Helpers/drupalComponentGrouper", null);
const PreviewActions = importer("Stores/Preview/Actions");
const { GROUP_FORM_SLUG } = importer("Sagas/Constants/drupalConstants", null);

export default function* main({ contentTypeMachineName, optionObject }) {
  try {
    const { lang, slug, previewId, previewerId } = optionObject;
    yield put(PreviewActions.getDrupalPreviewContentLoading());
    const toolkitContentResponse = (yield call(
      getMinStaticContent,
      contentTypeMachineName,
      {
        lang,
        slug,
        isPreview: true,
        previewId,
        previewerId,
      }
    ))[0];
    const parsedData = updateToolkitResponseForChildren(
      toolkitContentResponse?.contents
    );

    const groupFormFields = GROUP_FORM_SLUG[slug?.toUpperCase()];
    let contentsData = parsedData;
    if (groupFormFields) {
      contentsData = drupalFormFilter(parsedData, `form_data_${slug}`);
    }
    yield put(
      PreviewActions.getDrupalPreviewContentSuccess({
        metadata: toolkitContentResponse?.metadata,
        contents: contentsData,
      })
    );
  } catch (error) {
    yield put(PreviewActions.getDrupalPreviewContentFailure(error));
  }
}
